import httpStore from "@/api/httpStore.js";
import { getSavedState, saveState } from "@/helpers/LocalStorage.js";

// Conversaciones guardadas del usuario en el departamento actual (el API lo
// toma de X-Department-Code), la más reciente primero:
// [{ id, title, departmentCode, createdAt, updatedAt }]
export function listConversations() {
  return httpStore.get("/assistant_conversations/list").then(res => res.data);
}

// El historial y el estado de las tarjetas viajan como string JSON y se
// parsean aquí: el camelize de httpStore renombraría las claves del historial
// (tool_use_id, stop_reason...) y Claude lo rechazaría.
export function getConversation(id) {
  return httpStore
    .get(`/assistant_conversations/single/${id}`)
    .then(({ data }) => ({
      id: Number(data.id),
      title: data.title,
      messages: JSON.parse(data.messagesJson),
      uiState: data.uiStateJson ? JSON.parse(data.uiStateJson) : null
    }));
}

// Sin id la crea. Devuelve el id.
export function saveConversation({ id, title, messages, uiState }) {
  return httpStore
    .post("/assistant_conversations/save", {
      id: id || null,
      title,
      messages_json: JSON.stringify(messages),
      ui_state_json: JSON.stringify(uiState)
    })
    .then(res => Number(res.data.id));
}

export function deleteConversation(id) {
  return httpStore.delete(`/assistant_conversations/single/${id}`);
}

// La última abierta en cada departamento, para volver a ella al abrir la
// burbuja. Es sólo una comodidad: sin localStorage se empieza una nueva.
const LAST_KEY = "assistant.lastConversation";

export function getLastConversationId(departmentCode) {
  const saved = getSavedState(LAST_KEY);
  return (saved && saved[departmentCode]) || null;
}

export function setLastConversationId(departmentCode, id) {
  try {
    const saved = getSavedState(LAST_KEY) || {};
    saved[departmentCode] = id;
    saveState(LAST_KEY, saved);
  } catch (e) {
    // Sin localStorage (navegación privada, cuota): no pasa nada
  }
}
